export default __webpack_public_path__ + "static/media/bell-pepper-tablet.fd82ee14.png";